import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, PageSettingsModel, parentsUntil, QueryCellInfoEventArgs, RowSelectEventArgs, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { EmployeeService } from '../../employee/employee.service';
import { ColumnChangeBO, columnWidth } from '../../list/list.model';
import { GetBO } from '../../pages.modal';

import { BulkT2025UpdateBO, DeleteAllBO, DeletepermissionBO, EventEmitterBo, filters, functionpermission, getEvvtimesheetBO, saveactivitybo, saveEvvTimesheetBO, startenddateBo } from '../evvtimesheet.model';
import { EvvTimesheetService } from '../evvtimesheet.service';
import { EvvTimesheetListService } from './evvtimesheet-list.service';
// import { VisitsArchivedataService } from './evvtimesheet-listarchive.service';
import { EvvTimesheetDateListService } from './evvtimesheet-listdata.service';
import { EvvTimesheetEditService } from '../evvtimesheet-edit/evvtimesheet-edit.service';
import { CommonHttpService } from 'src/app/common.service';

@Component({
  selector: 'app-evvtimesheet-list',
  templateUrl: './evvtimesheet-list.component.html',
  styleUrls: ['./evvtimesheet-list.component.scss']
})

export class EvvtimesheetListComponent implements OnInit {
  @ViewChild('gridActive') public gridActive: GridComponent;
  @ViewChild('gridArchive') public gridArchive: GridComponent;
  OvernightFilter: string = "withoutOverNight";
  public data: Observable<DataStateChangeEventArgs>;
  public dataarchive: Observable<DataStateChangeEventArgs>;
  VisitSelectedTab = "Active";
  @ViewChild('gridTimesheet') public gridTimesheet: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  updateTimesheetInfo: saveEvvTimesheetBO = new saveEvvTimesheetBO();
  ActivetotalhoursSummaryMinutes: string;

  ArchivetotalhoursSummaryMinutes: string;
  ArchivetotalhoursSummary: number = 0;
  public formatOptions: object;
  updateWorkHours: string;
  payRate: string
  updateNotes: string;
  EmployeeMappedList: any = [];
  updateTimesheetDate: string;
  UpdateClient: string;
  locationLid: any;
  exportedDropData: any = ["true", "false"];
  deleteList: DeletepermissionBO = new DeletepermissionBO();
  multipleDelete: DeleteAllBO = new DeleteAllBO();
  multiDisable: boolean = false;
  UpdateEmployee: string;
  totalhoursSummaryMinutes: string;
  totalhoursSummary: number = 0;
  totalAmount: number;
  initialPage: PageSettingsModel;
  deletelist: DeletepermissionBO = new DeletepermissionBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  AllEmployeeDropDownList: any = [];
  AllClientDropDownList: any = [];
  ClientDropDownList: any = [];
  EndDateFilter: any;
  FromDateFilter: any;
  validationError: boolean = false;
  EmployeeListFilter: any;
  ClientListFilter: any;
  DeleteForms: FormGroup;
  @Input() ListInputProperty: EventEmitterBo = new EventEmitterBo();
  @Output() ListOutputTimesheet = new EventEmitter<EventEmitterBo>();
  resetPass: FormGroup;
  resetPassMulti: FormGroup;
  EvvTimesheetArchiveList: any = []
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  Activetablefilter: any = null;
  Archeivetablefilter: any = null;
  evvfilter: any = "unexported";
  ActiveAuthorizationList: any = [];
  IsButtonDisable: boolean = false;
  private DecimalColumns: string[] = ["RATE", "HOURS", "TOTALHOURS", "BALANCEAMOUNT"];
  constructor(public TListService: EvvTimesheetListService,
    public ngxService: NgxUiLoaderService,
    private CDR: ChangeDetectorRef,
    // public evvtimesheetarchive: VisitsArchivedataService,
    private employeeService: EmployeeService,
    public datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    public TService: EvvTimesheetService,
    public DateListService: EvvTimesheetDateListService,
    public global: GlobalComponent,
    public dateservice: DateService,
    public toasterservice: ToastrService, public general: GeneralService, public evvTimesheetSvc: EvvTimesheetEditService,
    public commonService: CommonHttpService) {
    this.GridList = DateListService;
    this.DeleteForms = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });
    this.resetPass = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });
    this.resetPassMulti = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });
    this.data = this.DateListService
    // console.log(this.data)
    this.dataarchive = this.DateListService


  }

  public checkparams;
  filterOptions: FilterSettingsModel;

  datetimeformatoption: object;
  public selectionOptions: SelectionSettingsModel
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  fp: functionpermission = new functionpermission()
  public AuthorizationinitialPage: PageSettingsModel;
  Activities: any[] = [];
  visitBulkUpdateBO = new BulkT2025UpdateBO();
  visitStatusSource: any = ["InProgress" , "Completed"];
  visitCustomType: any = ["Equal", "Not Equal"];
  ngOnInit(): void {
    this.filterOptions = { type: 'Menu' };
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {

      this.locationLid = this.global.globalLocationId;

    }
    else {
      this.locationLid = "00000000-0000-0000-0000-000000000000";
    }

    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.filterSettings = {
      type: 'Menu',
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.GetClientDropDown();
    this.GetAllClientDropDown();
    this.GetAllEmployeesDropdown();
    this.getVisitListFilter();
    this.getServiceList();
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[5], pageSizes: this.pageSizes };

    this.datetimeformatoption = { type: 'date', format: 'MM/dd/yyyy h:mm:ss a' };
    this.selectionOptions = {
      checkboxOnly: true
    }
    this.checkparams =
    {
      checked: false
    }

    this.startmin = new Date().toISOString().slice(0, 16)

    this.getpermission();

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "VISITS");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.TService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }





  //........................................GetClientDropDown.............................................
  GetClientDropDown() {
    this.TListService.GetClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  acttivitieslist: any = []
  GetActivities(data) {
    document.getElementById("activities").click();
    let params = new URLSearchParams();
    params.append("EvvId", data.id);
    params.append("ServiceId", data.serviceId);
    this.TListService.Getactivitieslist(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.acttivitieslist = data;

    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  //........................................GetAllClientDropDown.............................................
  GetAllClientDropDown() {
    this.TListService.GetAllClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllClientDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  //........................................GetAllEmployeesDropdown.............................................
  GetAllEmployeesDropdown() {
    this.TListService.GetAllEmployeesDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllEmployeeDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
      if (name == 'TimesheetDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          // this.updateTimesheetInfo.timesheetDate = element;
        }
      }
      if (name == 'StartDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {

          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.startDate = element;

        }

      }



      if (name == 'EndDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {

          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.endDate = element;

        }

      }

    }
    if (type == "datechanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;

        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
        }
      }
      if (name == 'TimesheetDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          // this.updateTimesheetInfo.timesheetDate = element;
        }
      }
      if (name == 'StartDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.startDate = element;

        }

      }

      if (name == 'EndDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.endDate = element;

        }

      }
    }
  }

  //////////////////////Update EvvTimeList////////////////////////////////////
  errorlist: any = []
  updateEvvTimesheet() {
    this.IsButtonDisable = true;
    let val = {
      evvTimesheetId: this.edittimesheetid,
      visitStartTime: this.global.getDateTimeString(this.editstart),
      visitEndTime: this.global.getDateTimeString(this.editend),
      note: this.editNotes,
      serviceId: this.service,
      visitTypeLid: this.visitTypeLid,
      updateReason: this.editreason,
      clientAuthorizationId: this.authId
    }



    this.TService.update(val).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      if (data?.length == 0) {
        this.valuechange = false;
        this.toasterservice.success("EvvTimesheet updated successfully!")
        document.getElementById("update").click();
        this.getVisitListFilter()

      }
      else {
        this.errorlist = data
        document.getElementById("errorpopup1").click();
      }
    }, (err: HttpErrorResponse) => {
      this.IsButtonDisable = false;
      this.toasterservice.error(err.error, 'error');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
    });
  }


  /////////////////////////////delete evvtiemsheet/////////////////
  deleteEvvTimesheet() {
    this.loading = this.IsButtonDisable = true;
    // let obj = { Admin_Password: this.deleteList.admin_Password }
    this.TService.deleteTimesheetdata(this.deleteList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.deleteList = new DeletepermissionBO();
      this.filterfunction();
      this.passerror = false;
      this.toasterservice.success(
        'EvvTimesheet deleted successfully!'
      ), 8000;

      document.getElementById("deleteTimes").click();
      this.getVisitListFilter()
      this.loading = false;
      this.passerror = false;
    },
      (err: HttpErrorResponse) => {
        this.IsButtonDisable = false;
        this.passerror = false;
        this.saveErr = err
        this.loading = false;
        setTimeout(() => {
          this.saveErr = ""
        }, 8000);
      }
    );
  }



  //.................................................getDetails............................................
  getDetails(list) {
    this.updateTimesheetInfo = JSON.parse(JSON.stringify(list));
    this.updateWorkHours = list.hours;
    if (list.timesheetDate != null) {
      // this.updateTimesheetInfo.timesheetDate = this.datePipe.transform(list.timesheetDate, 'MM/dd/yyyy');
    }
    if (list.clientId != null && list.clientId != undefined && list.clientId != '') {
      this.GetMappedEmployees();
    }
    this.totalAmount = list.totalAmount;
    this.payRate = list.payRate;
  }




  //....................................EvvTimesheetEmitpage......................................................
  EvvTimesheetEmitpage() {
    this.ListInputProperty.isCreate = true;
    this.ListInputProperty.isCreate = true;
    this.ListInputProperty.clientid = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.employeeid = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.serviceid = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.timesheetid = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.starttime = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.endtime = "00000000-0000-0000-0000-000000000000"
    this.ListInputProperty.ClientList = this.ClientDropDownList;

    this.ListOutputTimesheet.emit(this.ListInputProperty);
  }


  //....................................showTimesheetColumns......................................................
  showTimesheetColumns() {
    this.gridTimesheet.openColumnChooser(200, 50);
  }


  //.....................................................passvalid.................................................
  passvalid(event) {
    let str = event.target.value;
    let res;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str?.length >= 8) {
      this.validationError = false;
    }
    else {
      this.validationError = true;
    }

  }
  //...................................................CancelDelete...................................................
  CancelDelete() {
    this.deletelist = new DeletepermissionBO();
  }


  //.............................................numberonly......................................................
  numberonly(event: any, TimesheetType) {
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let text = "";
    if (TimesheetType == "UpdateTimesheet") {
      text = this.updateWorkHours;

    }
    text = (text.trim) ? text.trim() : text.replace(/^\s+/, '');
    if (text?.length == 1) {
      if (text == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(text) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (text == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    if (text?.length == 2) {
      let array = text.split("");
      if (!(array[1] == ".")) {
        if (array[0] == ".") {
          if (array[1] == "5" || array[1] == "0") {
            if (!(event.which == 48)) {
              event.preventDefault();
            }
          }
          if (array[1] == "2" || array[1] == "7") {
            if (!(event.which == 53)) {
              event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
          event.preventDefault();
        }

      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    if (text?.length == 3) {
      let array = text.split("");
      if (array[0] == ".") {
        event.preventDefault();
      }
      if (array[2] == ".") {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
      if (array[1] == ".") {
        let List = text.split(".");
        if (List[1] == "5" || List[1] == "0") {
          if (!(event.which == 48)) {
            event.preventDefault();
          }
        }
        if (List[1] == "2" || List[1] == "7") {
          if (!(event.which == 53)) {
            event.preventDefault();
          }
        }
      }
    }
    if (text?.length == 4) {
      let type = text.split(".");
      if (type[1]?.length == 2) {
        event.preventDefault();
      }
      if (type[1] == "5" || type[1] == "0") {
        if (!(event.which == 48)) {
          event.preventDefault();
        }
      }
      if (type[1] == "2" || type[1] == "7") {
        if (!(event.which == 53)) {
          event.preventDefault();
        }
      }
    }
    let val = text.split('.');
    if (text?.length > 4) {
      event.preventDefault();
    }
  }

  //.............................................CalculateTotalAmount......................................................
  CalculateTotalAmount() {

    if (this.updateWorkHours != null && this.updateWorkHours != undefined && this.updateWorkHours != '') {
      this.totalAmount = parseFloat(this.updateWorkHours) * parseFloat(this.payRate);
    }
    else {
      this.totalAmount = null;
    }
  }

  /////////////get mapped employees ////////////
  GetMappedEmployees() {
    let params = new URLSearchParams();
    params.append("clientId", this.updateTimesheetInfo.clientId);
    this.TService.GetMappedEmployees(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeMappedList = data;
    })
  }


  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ///////////////////// ejsgrid /////////////////




  showerrolist: any = [];

  errorlst(data) {
    this.showerrolist = data.errorList
  }




  // -----------------------------------for toolbar action--------------
  result3: any = [];
  result4: any = [];


  EvvtimesheetsendBO: getEvvtimesheetBO = new getEvvtimesheetBO();







  isEvvEnabledExcel: boolean = false;

  EvvTimesheetApproveFilter: string = "All";
  EvvTimesheetActiveList: any = [];
  SelectAllIdList: any = [];
  SelectAllArchiveIdList: any = [];
  EvvData: any = [];
  SelectAllActiveIdList: any = [];


  parentEvvTimeSheetId: any = [];
  selectAllValue: boolean = false;
  selected_data: any = [];
  selectAll: boolean;


  edittimesheetid: string = "00000000-0000-0000-0000-000000000000";
  visitTypeLid: string = "00000000-0000-0000-0000-000000000000";
  editEmployee: string = null;
  editClient: string = null;
  editDate: string = "";
  editservice: number = null;
  edittime: string = "";
  editNotes: string = "";
  editreason: string = '';
  editstart: string = "";
  saveErr: any = "";
  editend: string = ""
  reason: string = "";
  width: string;
  startmin: string = "";
  isbyweekly: boolean;
  service: string = "00000000-0000-0000-0000-000000000000"
  authId: string = "00000000-0000-0000-0000-000000000000";
  tempstarttoprevent: string = "";


  RefreshFilter() {

    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.EvvtimesheetsendBO.visitStartTime = this.global.getDateTimeString(this.FromDateFilter)
    this.EvvtimesheetsendBO.visitEndTime = this.global.getDateTimeString(this.EndDateFilter)
    this.EvvtimesheetsendBO.employeeId = null
    this.EvvtimesheetsendBO.clientId = null
    // this.gridTimesheet.clearFiltering();
    this.EvvtimesheetsendBO.type = "string";
    this.EvvtimesheetsendBO.value = "";
    this.getVisitListFilter();
  }
  evvid: string = '';
  evvTimesheet: any;
  EditEvvTimesheet(data) {
    this.evvTimesheet = data;
    this.edittimesheetid = data.id;
    // this.evvid=data.id
    this.editNotes = data.note
    this.visitTypeLid = data.visitTypeLid
    this.editEmployee = data.employeeName;
    this.editClient = data.clientName;
    this.editservice = data.serviceName;
    this.service = data.serviceId
    this.edittime = data.totalHours;
    this.editreason = data.reasonForModify
    let a = data.visitStartTime.split(':')
    let b = data.visitEndTime.split(':')
    this.editstart = a[0] + ':' + a[1]
    this.editend = b[0] + ':' + b[1]
    document.getElementById("update").click();
    this.authId = data.clientAuthorizationId;
    this.getActiveAuthorization();
    this.tempstarttoprevent = data.visitStartTime;
    this.checkStartDate();
  }


  iscreate: boolean = false;
  disabletimesheetUpdate: Boolean = false;

  checkStartDate() {
    if (!this.iscreate) {
      if (new Date(new Date(this.tempstarttoprevent).setHours(0, 0, 0, 0)).getTime() != new Date(new Date(this.editstart).setHours(0, 0, 0, 0)).getTime()) {
        this.disabletimesheetUpdate = true;
      }
      else {
        this.disabletimesheetUpdate = false;
      }
    }
  }
  public servicegroup: any = [];

  getgroup(val) {
    this.editservice = 0;
    if (val == null || val == "") {

      return
    }

    let head = new URLSearchParams()
    head.append("Client", val)
    this.TService.getservicegroupLst(head).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.servicegroup = data;
      this.servicegroup.forEach(element => {
        element.serviceId = element.serviceId.toString()
      });
    },
      (err: HttpErrorResponse) => {
        this.toasterservice.error(
          err.error,
          " Error"
        );
        setTimeout(() => {
          this.toasterservice.clear();
        }, 2000);
      }
    )

  }
  evvtimesheetnotes: string;

  shownotesdescription(notes) {
    this.evvtimesheetnotes = notes;
  }

  saveEvvErr: string = "";
  EmployeeDropDown: any
  ClinetDropDown: any;
  PayorDropDown: any;
  filters: filters = new filters();
  filterEndDatevalue: any;
  filterStartDatevalue: any;

  //============================Date time =============================================// 
  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'filterstart') {

        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          this.filters.filterStartDate = val1;

        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          this.filters.filterEndDate = val1;
        }
      }

    }
    if (type == "datechagned") {
      if (name == 'filterstart') {

        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.filters.filterStartDate = val1;
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.filters.filterEndDate = val1;
        }
      }

    }
  }
  newEvvtimedate(event, type, name) {
    if (type == "inputchage") {
      if (name == 'filterstart') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDatevalue = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterStartDatevalue = val1;
        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchangeReturnall(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);
          this.filterEndDatevalue = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();

          // this.filterEndDatevalue = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterEndDatevalue = val1;
        }
      }

    }
    if (type == "datechagned") {
      if (name == 'filterstart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);

          this.filterEndDatevalue = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();
          this.filterStartDatevalue = val1;

        }
      }
      if (name == 'filterend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          let enddate = new Date(event.value);
          enddate.setDate(enddate.getDate() + 6);

          this.filterEndDatevalue = (enddate.getMonth() + 1) + '/' + enddate.getDate() + '/' + enddate.getFullYear();

          this.filterEndDatevalue = val1;
        }
      }
    }
  }

  clearmodal() {
    this.isbyweekly = false;
  }

  //////////// get employeedropdown/////////////////
  getEmployeeDropDown() {
    let params = new URLSearchParams();
    params.append("AgencyId", this.global.globalAgencyId);
    // params.append("employeeId",empType);
    this.TService.getEmployee(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.EmployeeDropDown = data;

      this.EmployeeDropDown.forEach(element => {
        element.Key = element.Key.toString();

      })
    });

  }


  ////////////Calculate Hours/////////////////
  valuechange: boolean = false;
  hourscal() {
    this.valuechange = true;
    this.editservice = this.service = this.authId = null;
    if (this.iscreate) {
      this.editDate = this.datePipe.transform(this.editstart, "MM/dd/yyy");
    }

    if (this.editstart != null && this.editend != null && this.editstart != "" && this.editend != "") {
      if (new Date(this.editstart).getTime() <= new Date(this.editend).getTime()) {
        let start = new Date(this.editstart).getTime();
        let end = new Date(this.editend).getTime();
        let diff = end - start;

        var hours = Math.floor(diff / 1000 / 60 / 60);
        diff -= hours * 1000 * 60 * 60;
        var minutes = Math.floor(diff / 1000 / 60);
        if (minutes <= 7) {
          minutes = 0
        }
        else if (minutes <= 22) {
          minutes = 25
        }
        else if (minutes <= 37) {
          minutes = 50
        }
        else if (minutes <= 52) {
          minutes = 75
        }
        else {
          minutes = 0;
          hours += 1;
        }
        this.edittime = hours + "." + minutes;

      }
      else {
        this.saveEvvErr = "end time should greater than start time"
        setTimeout(() => {
          this.saveEvvErr = ""
        }, 2000);
      }
    }
  }

  passerror: boolean = false;
  public height = '220px';
  loading: boolean = false;


  /////////////////////////////filterfunction///////////////////

  filterfunction() {

    let tomorrow = new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1));
    if ((this.filters.filterStartDate == undefined || this.filters.filterStartDate == "") &&
      (this.filters.filterEndDate != undefined && this.filters.filterEndDate != "") ||
      ((this.filters.filterEndDate == undefined || this.filters.filterEndDate == "") && (this.filters.filterStartDate != undefined && this.filters.filterStartDate != ""))) {


      this.toasterservice.error('select start and end date', 'Warning');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      return;
    }
    if (new Date(this.filters.filterStartDate).getTime() >= tomorrow.getTime() || new Date(this.filters.filterEndDate).getTime() >= tomorrow.getTime()) {
      this.toasterservice.error('Start and End Date can not be a Future Date', 'Warning');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      return;
    }
    if (new Date(this.filters.filterStartDate).getTime() > new Date(this.filters.filterEndDate).getTime()) {
      this.toasterservice.error('End date should be grater than Start date', 'Warning');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      return;
    }

    this.EvvtimesheetsendBO.errortype = (this.EvvtimesheetsendBO.errortype != "" && this.EvvtimesheetsendBO.errortype != null && this.EvvtimesheetsendBO.errortype != undefined) ? this.EvvtimesheetsendBO.errortype : null;
    this.EvvtimesheetsendBO.evvstatus = (this.EvvtimesheetsendBO.evvstatus != "" && this.EvvtimesheetsendBO.evvstatus != null) ? this.EvvtimesheetsendBO.evvstatus == "true" ? true : false : null;
    this.EvvtimesheetsendBO.visitProgressStatus = (this.EvvtimesheetsendBO.visitProgressStatus != "" && this.EvvtimesheetsendBO.visitProgressStatus != undefined && this.EvvtimesheetsendBO.visitProgressStatus != null) ? this.EvvtimesheetsendBO.visitProgressStatus : null;
    this.EvvtimesheetsendBO.visitTypeName = (this.EvvtimesheetsendBO.visitTypeName != "" && this.EvvtimesheetsendBO.visitTypeName != undefined && this.EvvtimesheetsendBO.visitTypeName != null) ? this.EvvtimesheetsendBO.visitTypeName : null;
    // this.EvvtimesheetsendBO.visitStartTime = this.filters.filterStartDate != null ? this.global.getDateTimeString(this.filters.filterStartDate) : null
    // this.EvvtimesheetsendBO.visitEndTime = this.filters.filterEndDate != null ? this.global.getDateTimeString(this.filters.filterEndDate) : null
    this.getVisitListFilter();



  }

  ////////////////////////////signature////////////////////////

  imgrulclient: string = "";
  imgrulemployee: string = "";
  getsign(id) {
    let params = new URLSearchParams();
    params.append("id", id);
    this.TListService.Getsign(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.imgrulclient = data
      document.getElementById("viewsignclient").click();


    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  clearsign() {
    this.imgrulclient = ''
  }

  // viewsignclient(id) {



  //   document.getElementById("viewsignclient").click();

  // }
  // viewsignemployee(data) {

  //   this.imgrulemployee = data
  //   document.getElementById("viewsignemployee").click();

  // }





  serviceList: any = []
  getServiceList() {

    this.employeeService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList = data


    })
  }

  cancelMultiDelete() {
    this.multipleDelete = new DeleteAllBO();
    this.validationError = false;
    this.resetPassMulti.reset()
  }

  //------------------------------------------------------------------------------------------------------------------------- //

  selecToCheck(args) {
    if (this.VisitSelectedTab == 'Active') {

      if (args.checked && args.target.classList.contains('e-checkselectall')) {
        var rowData: any = this.gridActive.getSelectedRecords();
        this.parentEvvTimeSheetId = rowData.filter(cl => cl.clientId != null && cl.clientId != 0 && cl.clientId != '').map(evvId => evvId.id)
        this.selectAllValue = true;
        this.selected_data = [];
        this.SelectAllIdList.forEach(element => {
          this.selected_data.push(element.id);
        });
      }
      else if (args.target.classList.contains('e-checkselect')) {
        var rowfirst: any = this.gridActive.getSelectedRecords();
        this.parentEvvTimeSheetId = rowfirst.filter(cl => cl.clientId != null && cl.clientId != 0 && cl.clientId != '').map(evvId => evvId.id)
        this.selectAllValue = false;
        let result = this.gridActive.getRowInfo(args.target)
        let count = 0;
        let data: any = [];
        data = result.rowData;
        if (args.checked) {

          this.selected_data.push(data.id);

          this.selectAll = count > 0 ? false : true;
        }
        else {
          this.multiDisable = true;
          this.selectAll = false;
          // this.selectAllValue=false;
          const index: number = this.selected_data.indexOf(data.id);
          if (index !== -1) {
            this.selected_data.splice(index, 1);
          }
        }
      }
      else {
        this.selected_data = [];
        this.parentEvvTimeSheetId = [];
        this.selectAllValue = false;
      }
      if (this.selected_data == '' || this.selected_data == null || this.selected_data == undefined) {
        this.multiDisable = false;
      }
      else {
        this.multiDisable = true;
      }
    }
    else {
      if (args.checked && args.target.classList.contains('e-checkselectall')) {

        var rowData: any = this.gridArchive.getSelectedRecords();
        this.parentEvvTimeSheetId = rowData.filter(cl => cl.clientId != null && cl.clientId != 0 && cl.clientId != '').map(evvId => evvId.id)
        this.selectAllValue = true;
        this.selected_data = [];
        this.SelectAllIdList.forEach(element => {
          this.selected_data.push(element.id);
        });
      }
      else if (args.target.classList.contains('e-checkselect')) {
        var rowfirst: any = this.gridArchive.getSelectedRecords();
        this.parentEvvTimeSheetId = rowfirst.filter(cl => cl.clientId != null && cl.clientId != 0 && cl.clientId != '').map(evvId => evvId.id)
        this.selectAllValue = false;
        let result = this.gridArchive.getRowInfo(args.target)
        let count = 0;
        let data: any = [];

        data = result.rowData;
        if (args.checked) {

          this.selected_data.push(data.id);

          this.selectAll = count > 0 ? false : true;
        }
        else {
          this.multiDisable = true;
          this.selectAll = false;
          // this.selectAllValue=false;
          const index: number = this.selected_data.indexOf(data.id);
          if (index !== -1) {
            this.selected_data.splice(index, 1);
          }
        }
      }
      else {
        this.selected_data = [];
        this.parentEvvTimeSheetId = [];
        this.selectAllValue = false;
      }
      if (this.selected_data == '' || this.selected_data == null || this.selected_data == undefined) {
        this.multiDisable = false;
      }
      else {
        this.multiDisable = true;
      }
    }


  }


  //------------------------------------------------------------------------------------------------------------------------- //
  deleteMultipleTimesheet() {
    this.multipleDelete.evvId = this.selected_data;
    this.loading = true;
    this.TService.deleteMultiTimesheetdata(this.multipleDelete).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.multipleDelete = new DeleteAllBO();

      this.filterfunction();
      this.passerror = false;

      this.toasterservice.success(
        'EvvTimesheet deleted successfully!'
      ), 8000;
      this.selected_data = []
      document.getElementById("Multidelete").click();
      this.getVisitListFilter()
      this.loading = false;
      this.passerror = false;
      this.multiDisable = false;
    },
      (err: HttpErrorResponse) => {
        this.passerror = false;
        this.saveErr = err;
        this.loading = false;
        this.selected_data = []
        setTimeout(() => {
          this.saveErr = ""
        }, 8000);
      }
    );
  }


  viewlocation(startGPSLat, startGPSLon) {
    window.open("https://maps.google.com/maps?q=" + startGPSLat + ',' + startGPSLon);
  }


  startenddateBo: startenddateBo = new startenddateBo()

  clearTax() {
    this.startDate = null;
    this.endDate = null;
  }
  startDate: any
  endDate: any
  UpdateRateTimesheet() {

    this.startenddateBo.startDate = this.global.getDateTimeString(this.startDate);
    this.startenddateBo.endDate = this.global.getDateTimeString(this.endDate);
    this.TListService.UpdateRateTimesheet(this.startenddateBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.toasterservice.success("timesheet updated Successfully");
        document.getElementById('UpdateRatetimesheet').click();
        this.getVisitListFilter()


      }

    },

      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })

  }


  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  tabchange(val) {
    this.VisitSelectedTab = val;
    this.parentEvvTimeSheetId = [];
    this.selected_data = []
    this.getVisitListFilter();
  }

  getVisitListFilter() {
    // console.log(this.OvernightFilter, "this.OvernightFilter")
    if (this.OvernightFilter == "withoutOverNight") {
      this.EvvtimesheetsendBO.isOverNight = null;
    }
    else if (this.OvernightFilter == "withOverNight") {
      this.EvvtimesheetsendBO.isOverNight = true;
    }
    if (this.EvvTimesheetApproveFilter == "All") {
      this.EvvtimesheetsendBO.isApproved = null;
    }
    else if (this.EvvTimesheetApproveFilter == "Approve") {
      this.EvvtimesheetsendBO.isApproved = true;
    }
    else {
      this.EvvtimesheetsendBO.isApproved = false;
    }
    this.EvvtimesheetsendBO.isExported = this.evvfilter;
    if (this.VisitSelectedTab == 'Active') {
      this.EvvtimesheetsendBO.pageitem = this.gridActive != undefined ? this.gridActive.pageSettings.pageSize : 10;
      this.Activetablefilter = JSON.parse(JSON.stringify(this.EvvtimesheetsendBO))
    }
    else if (this.VisitSelectedTab == 'Archive') {
      this.EvvtimesheetsendBO.pageitem = this.gridArchive.pageSettings.pageSize;
      this.Archeivetablefilter = JSON.parse(JSON.stringify(this.EvvtimesheetsendBO))
    }
    // if((this.EvvtimesheetsendBO.type != "string" || this.EvvtimesheetsendBO.type == null || this.EvvtimesheetsendBO.type == undefined) && (this.EvvtimesheetsendBO.value == "" 
    //   || this.EvvtimesheetsendBO.value == undefined || this.EvvtimesheetsendBO.value == null)){
    //   this.EvvtimesheetsendBO.currentpageno = 1;
    //   this.EvvtimesheetsendBO.pageitem = 10;
    //   this.EvvtimesheetsendBO.operator = "startswith"
    //   this.EvvtimesheetsendBO.type = "string";
    //   this.EvvtimesheetsendBO.value = "";
    //   this.EvvtimesheetsendBO.field = "clientName";
    //   this.EvvtimesheetsendBO.orderColumn = "clientName";
    //   this.EvvtimesheetsendBO.orderType = 'ASC';
    //   }
    if (this.VisitSelectedTab == 'Active') {
      this.EvvtimesheetsendBO.isEvvArchived = false;
      // this.EvvtimesheetsendBO.errortype = (this.EvvtimesheetsendBO.errortype != "" && this.EvvtimesheetsendBO.errortype != null && this.EvvtimesheetsendBO.errortype != undefined) ? this.EvvtimesheetsendBO.errortype : null;
      // this.EvvtimesheetsendBO.evvstatus = (this.EvvtimesheetsendBO.evvstatus != "" && this.EvvtimesheetsendBO.evvstatus != null) ? this.EvvtimesheetsendBO.evvstatus == "true" ? true : false : null;
      // this.EvvtimesheetsendBO.visitProgressStatus = (this.EvvtimesheetsendBO.visitProgressStatus != "" && this.EvvtimesheetsendBO.visitProgressStatus != undefined && this.EvvtimesheetsendBO.visitProgressStatus != null) ? this.EvvtimesheetsendBO.visitProgressStatus : null;
      // this.EvvtimesheetsendBO.visitTypeName = (this.EvvtimesheetsendBO.visitTypeName != "" && this.EvvtimesheetsendBO.visitTypeName != undefined && this.EvvtimesheetsendBO.visitTypeName != null) ? this.EvvtimesheetsendBO.visitTypeName : null;
      this.EvvtimesheetsendBO.visitStartTime = this.global.getDateTimeString(this.FromDateFilter)
      this.EvvtimesheetsendBO.visitEndTime = this.global.getDateTimeString(this.EndDateFilter)
      this.DateListService.execute(this.EvvtimesheetsendBO)
      let count = 0;
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SelectAllIdList = data.result;
        this.EvvData = data.result;
        if ((data != null && data.result?.length > 0)) {
          this.isEvvEnabledExcel = true;
        }
        else {
          this.isEvvEnabledExcel = false;
        }



        if (this.global.globalAgencyId != 0) {
          if (data != null && data.result?.length > 15) {
            this.gridActive.height = '500';
          }
          else {
            this.gridActive.height = 'auto';
          }
        }
        count = count + 1;
        if (data != null && data != undefined && count == 1) {

          //this.getColumnwidth()
        }
      }
      )
    }
    else if (this.VisitSelectedTab == 'Archive') {
      this.EvvtimesheetsendBO.isEvvArchived = true;
      this.EvvtimesheetsendBO.visitStartTime = this.global.getDateTimeString(this.FromDateFilter)
      this.EvvtimesheetsendBO.visitEndTime = this.global.getDateTimeString(this.EndDateFilter)
      this.DateListService.execute(this.EvvtimesheetsendBO)
      let count = 0;
      this.dataarchive.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.SelectAllIdList = data.result;
        this.EvvData = data.result;


        if ((data != null && data.result?.length > 0)) {
          this.isEvvEnabledExcel = true;
        }
        else {
          this.isEvvEnabledExcel = false;
        }
        if (this.global.globalAgencyId != 0) {
          if (data != null && data.result?.length > 15) {
            this.gridArchive.height = '500';
          }
          else {
            this.gridArchive.height = 'auto';
          }
        }
      }
      )
    }
  }


  //...........................................................validatebutton..........................................
  validatebutton(args) {
    // if (args.column.field == "evvtimesheet") {
    //   if (args.data['isExported'] == true) {
    //     args.cell.children[0].classList.add('disableedit');
    //     args.cell.children[1].classList.add('disableedit');
    //   }
    // }
    if (args.column.field == "isClientSign") {
      if (args.data['isClientSign'] == false) {
        args.cell.firstElementChild.classList.add('disableedit')
      }
    }
    if (args.column.field == "isEmployeeSign") {
      if (args.data['isEmployeeSign'] == false) {
        args.cell.firstElementChild.classList.add('disableedit')
      }
    }
    if (args.column.field == "Start Location") {
      if (args.data['clockInCallLatitude'] == "" || args.data['clockInCallLatitude'] == null || args.data['clockInCallLongitude'] == null || args.data['clockInCallLongitude'] == "") {
        args.cell.firstElementChild.classList.add('disableedit')
      }
    }
    if (args.column.field == "End Location") {
      if (args.data['clockOutCallLatitude'] == "" || args.data['clockOutCallLatitude'] == null || args.data['clockOutCallLongitude'] == null || args.data['clockOutCallLongitude'] == "") {
        args.cell.firstElementChild.classList.add('disableedit')
      }
    }

  }

  //.......................................rowDataBound.....................................................//
  rowDataBound(args) {
    if (args.data['over24HourswithOutClockOut'] == true) {

      args.row.style.background = '#f39146';

    }

  }



  // -----------------------------------for toolbar action--------------
  //  gettoolbardata(args) {
  //   alert("toolbar");
  //   if (args.data['onHold'] == true) {
  //     // args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
  //     // args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')
  //   }
  //   var grid = (parentsUntil(args.target, 'e-grid') as any);

  //   this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;


  // }

  //===================================data state===================================//
  public dataStateChange(state): void {
    let type: String = (state.action.requestType).toString();
    this.EvvtimesheetsendBO.currentpageno = this.gridActive.pagerModule.pagerObj.currentPage;
    this.EvvtimesheetsendBO.pageitem = this.gridActive.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.EvvtimesheetsendBO.orderColumn = state.sorted[0].name;
        this.EvvtimesheetsendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      // this.EvvtimesheetsendBO.currentpageno = 1;
      // this.EvvtimesheetsendBO.pageitem = 10;
      this.EvvtimesheetsendBO.value = state.action.currentFilterObject.value;
      this.EvvtimesheetsendBO.field = state.action.currentFilterObject.field;
      this.EvvtimesheetsendBO.operator = state.action.currentFilterObject.operator;
      this.EvvtimesheetsendBO.matchCase = state.action.currentFilterObject.matchCase;
      if (this.EvvtimesheetsendBO.type == "date") {
        this.EvvtimesheetsendBO.value =(!isNaN(Date.parse(this.EvvtimesheetsendBO.value)))
        ? (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "")
        : null;
      }
      // else {
      //   this.EvvtimesheetsendBO.value = state.action.currentFilterObject.value
      // }
      this.EvvtimesheetsendBO.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isClientSign") {
        this.EvvtimesheetsendBO.value = this.EvvtimesheetsendBO.value == 'Yes' ? 'true' : 'false';
        this.EvvtimesheetsendBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "isEmployeeSign") {
        this.EvvtimesheetsendBO.value = this.EvvtimesheetsendBO.value == 'Yes' ? 'true' : 'false';
        this.EvvtimesheetsendBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.EvvtimesheetsendBO.field = "timesheetStatus"
        this.EvvtimesheetsendBO.type = "string";
      }
      if (state.action.currentFilterObject.type == "number") {
          this.EvvtimesheetsendBO.value = (this.EvvtimesheetsendBO.value != null || this.EvvtimesheetsendBO.value == undefined)? this.EvvtimesheetsendBO.value.toString(): null;
      }
      // if (state.action.currentFilterObject.field == "dailyAuthorizedhours") {
      //   this.EvvtimesheetsendBO.value = this.EvvtimesheetsendBO.value.toString();
      // }
      this.EvvtimesheetsendBO.operator = state.action.currentFilterObject.operator;
    }
    if ((state.action.requestType == "filtering" && state.action.action == "clearFilter") ||
      (this.EvvtimesheetsendBO.type != 'string' && (this.EvvtimesheetsendBO.value == ""
        || this.EvvtimesheetsendBO.value == undefined || this.EvvtimesheetsendBO.value == null))) {
      // this.EvvtimesheetsendBO.currentpageno = 1;
      // this.EvvtimesheetsendBO.pageitem = 10;
      this.EvvtimesheetsendBO.operator = "startswith"
      this.EvvtimesheetsendBO.type = "string";
      this.EvvtimesheetsendBO.value = "";
      this.EvvtimesheetsendBO.field = "clientName";
    }
    if (this.DecimalColumns.includes(this.EvvtimesheetsendBO.field.toUpperCase())) {
      this.EvvtimesheetsendBO.type = "decimal";
    }
    if (state.action.requestType != "refresh") {
      this.getVisitListFilter();
    }

  }
  //===================================data state===================================//
  public dataStateChangeArchive(state): void {
    let type: String = (state.action.requestType).toString();
    this.EvvtimesheetsendBO.currentpageno = this.gridArchive.pagerModule.pagerObj.currentPage;
    this.EvvtimesheetsendBO.pageitem = this.gridArchive.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.EvvtimesheetsendBO.orderColumn = state.sorted[0].name;
        this.EvvtimesheetsendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';

      }
    }

    if (type == "filtering" && state.action.action != "clearFilter") {
      // this.EvvtimesheetsendBO.currentpageno = 1;
      // this.EvvtimesheetsendBO.pageitems = 10;
      this.EvvtimesheetsendBO.value = state.action.currentFilterObject.value;
      this.EvvtimesheetsendBO.field = state.action.currentFilterObject.field;
      this.EvvtimesheetsendBO.operator = state.action.currentFilterObject.operator;
      this.EvvtimesheetsendBO.matchCase = state.action.currentFilterObject.matchCase;
      if (this.EvvtimesheetsendBO.type == "date") {
        this.EvvtimesheetsendBO.value = (!isNaN(Date.parse(this.EvvtimesheetsendBO.value)))
        ? this.global.getDateTimeString(this.EvvtimesheetsendBO.value)
        : null;
      }
      // else {
      //   this.EvvtimesheetsendBO.value = state.action.currentFilterObject.value
      // }
      this.EvvtimesheetsendBO.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isClientSign") {
        this.EvvtimesheetsendBO.value = this.EvvtimesheetsendBO.value == 'Yes' ? 'true' : 'false';
        this.EvvtimesheetsendBO.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "isEmployeeSign") {
        this.EvvtimesheetsendBO.value = this.EvvtimesheetsendBO.value == 'Yes' ? 'true' : 'false';
        this.EvvtimesheetsendBO.type = "boolean"
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.EvvtimesheetsendBO.field = "timesheetStatus"
        this.EvvtimesheetsendBO.type = "string"
      }
      if(this.EvvtimesheetsendBO.type == "number"){
        this.EvvtimesheetsendBO.value = (this.EvvtimesheetsendBO.value!=null && this.EvvtimesheetsendBO.value!=undefined)
        ?this.EvvtimesheetsendBO.value.toString() : null;
      }
    }
    if((state.action.requestType == "filtering" && state.action.action == "clearFilter") || 
      (this.EvvtimesheetsendBO.type != 'string' && (this.EvvtimesheetsendBO.value == "" || this.EvvtimesheetsendBO.value == undefined
      || this.EvvtimesheetsendBO.value == null || this.EvvtimesheetsendBO.value==''))){
      // this.EvvtimesheetsendBO.currentpageno = 1;
      // this.EvvtimesheetsendBO.pageitem = 10;
      this.EvvtimesheetsendBO.operator = "startswith"
      this.EvvtimesheetsendBO.type = "string";
      this.EvvtimesheetsendBO.value = "";
      this.EvvtimesheetsendBO.field = "clientName";
    }
    if (this.DecimalColumns.includes(this.EvvtimesheetsendBO.field.toUpperCase())) {
      this.EvvtimesheetsendBO.type = "decimal";
    }
    if (state.action.requestType != "refresh") {
      this.getVisitListFilter();
    }
    if (state.action.requestType == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol?.length != 0) {
        if (this.VisitSelectedTab == "Active") {
          if (this.arraycol[0].EVV_Timesheet.Pagesize != state.take) {
            this.arraycol[0].EVV_Timesheet.Pagesize = state.take
            //this.SaveColumnwidth();
          }
        }
        else if (this.VisitSelectedTab == "Archive") {
          if (this.arraycol[0].EVV_Timesheet_Archive.Pagesize != state.take) {
            this.arraycol[0].EVV_Timesheet_Archive.Pagesize = state.take
            //this.SaveColumnwidth();
          }
        }
      }
    }
  }
  //=================================== Tooltip ====================================//
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString()
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  arraycol: any = [];
  ColumnArray: columnWidth[];
  ColumnArray_archive: columnWidth[];
  id: string = '00000000-0000-0000-0000-000000000000';
  columnchange: ColumnChangeBO = new ColumnChangeBO();

  //...........................................................SaveColumnwidth..........................................
  //  SaveColumnwidth() {
  //   this.arraycol[0].EVV_Timesheet.Columns = this.ColumnArray;
  //   this.arraycol[0].EVV_Timesheet.Pagesize = this.gridActive.pageSettings.pageSize;
  //   this.arraycol[0].EVV_Timesheet_Archive.Columns = this.ColumnArray_archive;
  //   this.arraycol[0].EVV_Timesheet_Archive.Pagesize = this.gridArchive.pageSettings.pageSize;
  //   this.columnchange.agencyId = this.global.globalAgencyId;
  //   this.columnchange.userid =this.global.userID;
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;
  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.TService.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     //this.getColumnwidth()
  //   });
  // }

  // getColumnwidth() {
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.ColumnArray = this.arraycol[0].EVV_Timesheet.Columns;
  //   this.ColumnArray_archive = this.arraycol[0].EVV_Timesheet_Archive.Columns;
  //   let showcol = this.arraycol[0].EVV_Timesheet.ShowColumns;
  //   let hidecol = this.arraycol[0].EVV_Timesheet.HideColumns
  //   let showcol_archive = this.arraycol[0].EVV_Timesheet_Archive.ShowColumns;
  //   let hidecol_archive = this.arraycol[0].EVV_Timesheet_Archive.HideColumns
  //   this.gridActive.hideColumns(hidecol);
  //   this.gridArchive.hideColumns(hidecol_archive);
  //   if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
  //     this.id = this.global.globalColumn.id;
  //   }
  //   this.gridActive.pageSettings.pageSize = this.arraycol[0].EVV_Timesheet.Pagesize;
  //   this.gridArchive.pageSettings.pageSize = this.arraycol[0].EVV_Timesheet_Archive.Pagesize;
  //   if (this.VisitSelectedTab == 'Active') {
  //     this.ColumnArray.forEach(element => {
  //       if (element.column == '') {
  //         const column = this.gridActive.getColumnByUid('checkbox');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridActive.refreshHeader();
  //         //this.grid.refreshColumns();
  //       }
  //       if (element.column == 'Client') {
  //         const column = this.gridActive.getColumnByField('clientName');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridActive.refreshHeader();
  //         //this.grid.refreshColumns();
  //       }
  //       if (element.column == 'Employee') {
  //         const column1 = this.gridActive.getColumnByField('employeeName');
  //         column1.headerText = element.column;
  //         column1.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       // if (element.column == 'Timesheet Date') {

  //       //   const column2 = this.grid.getColumnByField('scheduleDate'); // get the JSON object of the column corresponding to the field name
  //       //   column2.headerText = element.column;
  //       //   column2.width = element.width;

  //       //   this.grid.refreshHeader();
  //       // }
  //       if (element.column == 'Start Time') {
  //         const column3 = this.gridActive.getColumnByField('visitStartTime');
  //         column3.headerText = element.column;
  //         column3.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'End Time') {
  //         const column4 = this.gridActive.getColumnByField('visitEndTime');
  //         column4.headerText = element.column;
  //         column4.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Clent Signature') {
  //         const column5 = this.gridActive.getColumnByField('isClientSign');
  //         column5.headerText = element.column;
  //         column5.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Employee Signature') {
  //         const column6 = this.gridActive.getColumnByField('isEmployeeSign');
  //         column6.headerText = element.column;
  //         column6.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Total hours') {
  //         const column7 = this.gridActive.getColumnByField('totalHours');
  //         column7.headerText = element.column;
  //         column7.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Transaction Status') {
  //         const column8 = this.gridActive.getColumnByField('transactionstatus');
  //         column8.headerText = element.column;
  //         column8.width = element.width;

  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Daily Authorized Hours') {
  //         const column7 = this.gridActive.getColumnByField('dailyAuthorizedhours');
  //         column7.headerText = element.column;
  //         column7.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Service') {
  //         const column8 = this.gridActive.getColumnByField('masterServiceName');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Start Location') {
  //         const column8 = this.gridActive.getColumnByField('Start Location');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'End Location') {
  //         const column8 = this.gridActive.getColumnByField('End Location');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Reason') {
  //         const column9 = this.gridActive.getColumnByField('reasonForModify');
  //         column9.headerText = element.column;
  //         column9.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'ModifiedBy') {
  //         const column10 = this.gridActive.getColumnByField('modifiedBy');
  //         column10.headerText = element.column;
  //         column10.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Exported') {
  //         const column10 = this.gridActive.getColumnByField('isExported');
  //         column10.headerText = element.column;
  //         column10.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Actions') {
  //         const column11 = this.gridActive.getColumnByUid('action');
  //         column11.headerText = element.column;
  //         column11.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Validate') {
  //         const column12 = this.gridActive.getColumnByField('validate');
  //         column12.headerText = element.column;
  //         column12.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Approved') {
  //         const column = this.gridActive.getColumnByField('isApproved');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //       if (element.column == 'Notes') {
  //         const column11 = this.gridActive.getColumnByUid('note');
  //         column11.headerText = element.column;
  //         column11.width = element.width;
  //         this.gridActive.refreshHeader();
  //       }
  //     });
  //   }
  //   else {
  //     console.log(this.ColumnArray_archive)
  //     this.ColumnArray_archive.forEach(element => {
  //       if (element.column == '') {
  //         const column = this.gridArchive.getColumnByUid('checkbox');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridArchive.refreshHeader();
  //         //this.grid.refreshColumns();
  //       }
  //       if (element.column == 'Client') {
  //         const column = this.gridArchive.getColumnByField('clientName');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridArchive.refreshHeader();
  //         //this.grid.refreshColumns();
  //       }
  //       if (element.column == 'Employee') {
  //         const column1 = this.gridArchive.getColumnByField('employeeName');
  //         column1.headerText = element.column;
  //         column1.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       // if (element.column == 'Timesheet Date') {

  //       //   const column2 = this.gridArchive.getColumnByField('scheduleDate'); // get the JSON object of the column corresponding to the field name
  //       //   column2.headerText = element.column;
  //       //   column2.width = element.width;

  //       //   this.gridArchive.refreshHeader();
  //       // }
  //       if (element.column == 'Start Time') {
  //         const column3 = this.gridArchive.getColumnByField('visitStartTime');
  //         column3.headerText = element.column;
  //         column3.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Notes') {
  //         const column11 = this.gridArchive.getColumnByUid('note');
  //         column11.headerText = element.column;
  //         column11.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'End Time') {
  //         const column4 = this.gridArchive.getColumnByField('visitEndTime');
  //         column4.headerText = element.column;
  //         column4.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Clent Signature') {
  //         const column5 = this.gridArchive.getColumnByField('isClientSign');
  //         column5.headerText = element.column;
  //         column5.width = element.width;

  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Employee Signature') {
  //         const column6 = this.gridArchive.getColumnByField('isEmployeeSign');
  //         column6.headerText = element.column;
  //         column6.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Total hours') {
  //         const column7 = this.gridArchive.getColumnByField('totalHours');
  //         column7.headerText = element.column;
  //         column7.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Transaction Status') {
  //         const column8 = this.gridArchive.getColumnByField('transactionstatus');
  //         column8.headerText = element.column;
  //         column8.width = element.width;

  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Daily Authorized Hours') {
  //         const column7 = this.gridArchive.getColumnByField('dailyAuthorizedhours');
  //         column7.headerText = element.column;
  //         column7.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Service') {
  //         const column8 = this.gridArchive.getColumnByField('masterServiceName');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Start Location') {
  //         const column8 = this.gridArchive.getColumnByField('Start Location');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'End Location') {
  //         const column8 = this.gridArchive.getColumnByField('End Location');
  //         column8.headerText = element.column;
  //         column8.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Reason') {
  //         const column9 = this.gridArchive.getColumnByField('reasonForModify');
  //         column9.headerText = element.column;
  //         column9.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'ModifiedBy') {
  //         const column10 = this.gridArchive.getColumnByField('modifiedBy');
  //         column10.headerText = element.column;
  //         column10.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Exported') {
  //         const column10 = this.gridArchive.getColumnByField('isExported');
  //         column10.headerText = element.column;
  //         column10.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Actions') {
  //         const column11 = this.gridArchive.getColumnByUid('action');
  //         column11.headerText = element.column;
  //         column11.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Validate') {
  //         const column12 = this.gridArchive.getColumnByField('validate');
  //         column12.headerText = element.column;
  //         column12.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //       if (element.column == 'Approved') {
  //         const column = this.gridArchive.getColumnByField('isApproved');
  //         column.headerText = element.column;
  //         column.width = element.width;
  //         this.gridArchive.refreshHeader();
  //       }
  //     });
  //   }
  // }


  //...........................................................onResize..........................................
  onResize(args) {
    // const column = this.gridActive.getColumnByField(args.column.field)
    // column.width = args.column.width;
    // this.ColumnArray.forEach(element => {
    //   if (element.column == column.headerText) {
    //     element.width = parseInt(column.width.toString());
    //   }
    // });
    //this.SaveColumnwidth();
  }
  //...........................................................onResize_archive..........................................
  onResize_archive(args) {
    const column = this.gridArchive.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray_archive.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });
    //this.SaveColumnwidth();
  }


  //===================================Action Complete===================================//
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridActive.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].EVV_Timesheet.ShowColumns?.length != count1 || this.arraycol[0].EVV_Timesheet.HideColumns?.length != count) {
            this.arraycol[0].EVV_Timesheet.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }

      }
    }
    if (args.requestType == "filterafteropen") {
      this.EvvtimesheetsendBO.type = args.columnType;
    }
  }
  public onActionCompleteArchive(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridArchive.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet_Archive.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet_Archive.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].EVV_Timesheet_Archive.ShowColumns?.length != count1 || this.arraycol[0].EVV_Timesheet_Archive.HideColumns?.length != count) {
            this.arraycol[0].EVV_Timesheet_Archive.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet_Archive.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }
      }
    }
    if (args.requestType == "filterafteropen") {
      this.EvvtimesheetsendBO.type = args.columnType;
    }
  }

  //===================================Show column settings===================//
  show() {
    // console.log("this.gridActive", this.gridActive)
    this.gridActive.columnChooserModule.openColumnChooser(); // give X and Y axis
  }
  showarchive() {
    // console.log("this.gridArchive", this.gridArchive)
    this.gridArchive.columnChooserModule.openColumnChooser(); // give X and Y axis
  }

  selectTab(event) {
    if (event.target.innerText == "Active") {
      this.EvvtimesheetsendBO.isEvvArchived = false;
      this.getVisitListFilter();
    }
    if (event.target.innerHTML == "Archive") {
      this.EvvtimesheetsendBO.isEvvArchived = true;
      this.getVisitListFilter();
    }
  }
  selectedAllBoolean: boolean = false;


  //.............................................MoveToArchive....................................................
  MoveToArchive() {
    this.IsButtonDisable = true;
    this.TListService.MoveToArchive(this.selected_data).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.IsButtonDisable = false;
      this.getVisitListFilter();
      this.selected_data = [];
      this.toasterservice.success('Move to archive successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
    },
      (err: HttpErrorResponse) => {
        this.IsButtonDisable = false;
        this.toasterservice.error(err.error, 'error');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      })
  }
  //.............................................MoveToActive....................................................
  MoveToActive() {
    this.IsButtonDisable = true;
    this.TListService.MoveToActive(this.selected_data).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.IsButtonDisable = false;
      this.getVisitListFilter();
      this.selected_data = [];
      this.toasterservice.success('Move to active successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
    },
      (err: HttpErrorResponse) => {
        this.IsButtonDisable = false;
        this.toasterservice.error(err.error, 'error');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      })
  }


  //.....................................................evvMarkedCheckbox.............................................
  evvMarkedCheckbox(boolean) {
    this.IsButtonDisable = true;
    if (boolean == false) {
      this.TListService.MarkedasApproved(this.selected_data).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.IsButtonDisable = false;
        this.toasterservice.success("Approved");
        this.selected_data = [];
        this.getVisitListFilter();
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toasterservice.error(err.error, 'error');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        })
    }
    else {
      this.TListService.MarkedasunApproved(this.selected_data).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.IsButtonDisable = false;
        this.selected_data = [];
        this.toasterservice.success("UnApproved");
        this.getVisitListFilter();
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.toasterservice.error(err.error, 'error');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        })
    }
  }

  closeerror() {
    this.errorlist = []
  }



  exportCsv() {
    let url = "api/Visit/GetVisitReport"
    this.TListService.saveorUpdateFunctionFileSaver(this.EvvtimesheetsendBO, url, "VisitReport.csv");

    // this.TListService.exportcsv(this.EvvtimesheetsendBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    // console.log(data,"data")
    // let contentType = 'text/csv';
    // const blob = this.b64toBlob(data, contentType);
    // const blobUrl = URL.createObjectURL(blob);
    // const a = document.createElement('a');
    // a.href = blobUrl;
    // a.download = "Visit Export";
    // a.click();

    // },
    // (err: HttpErrorResponse) => {
    //   this.toasterservice.error(
    //     err.error

    //   );
    // })

  }

  b64toBlob = (b64Data, contentType: any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  ClearErrmsg() {
    if (this.saveErr != "") {
      this.saveErr = "";
    }
  }

  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'balanceAmount') {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add('mark');
      }
    }
  }

  //....................................rowSelected........................................................
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.editservice = rowList.serviceCodeName;
    this.service = rowList.serviceId;
    this.authId = rowList.id;

  }

  //........................................getActiveAuthorization.......................................
  getActiveAuthorization() {
    if (this.evvTimesheet.clientId != null && this.evvTimesheet.clientId != undefined && this.evvTimesheet.clientId != '' &&
      this.evvTimesheet.employeeId != null && this.evvTimesheet.employeeId != undefined && this.evvTimesheet.employeeId != '' &&
      this.editstart != null && this.editstart != undefined && this.editstart != '' &&
      this.editend != null && this.editend != undefined && this.editend != '') {
      this.AuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 5, pageSize: 5, pageSizes: [5, 10, 15, 20] };
      let params = new URLSearchParams();
      params.append("clientId", this.evvTimesheet.clientId);
      params.append("fromDate", this.global.getDateTimeString(this.editstart));
      params.append("toDate", this.global.getDateTimeString(this.editend));
      params.append("employeeId", this.evvTimesheet.employeeId);
      this.evvTimesheetSvc.getActiveAuthsWithinDateRange(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.ActiveAuthorizationList = data;
      })
    }
  }
  public UpdateAuthorizationinitialPage: PageSettingsModel;
  UpdateAuthorizationList: any = [];
  IsBulkUpdate: boolean = false;
  getBulkUpdateActiveAuths() {
    this.UpdateAuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: 10, pageSizes: [10, 15, 20, 25] };
    let params = new URLSearchParams();
    params.append("clientId", this.EvvtimesheetsendBO.clientId);
    params.append("fromDate", this.global.getDateTimeString(this.FromDateFilter));
    params.append("toDate", this.global.getDateTimeString(this.EndDateFilter));
    params.append("employeeId", this.EvvtimesheetsendBO.employeeId);
    this.evvTimesheetSvc.getActiveAuthsWithinDateRange(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UpdateAuthorizationList = data;
      this.IsBulkUpdate = true;
    })
  }
  bulkUpdateService;
  bulkUpdateAuthId;
  bulkServiceId;
  //....................................rowSelected........................................................
  rowSelectedForBulkVisitUpdate(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.bulkUpdateService = rowList.serviceCodeName;
    this.bulkServiceId = rowList.serviceId;
    this.bulkUpdateAuthId = rowList.id;

  }

  updatebulkvisits() {
    this.IsBulkUpdate = false;
    this.IsButtonDisable = true;
    // var visitIds = this.EvvData.map(evv => evv.id);
    // this.visitBulkUpdateBO.evvIds = visitIds;
    this.visitBulkUpdateBO.clientId = this.EvvtimesheetsendBO.clientId;
    this.visitBulkUpdateBO.employeeId = this.EvvtimesheetsendBO.employeeId;
    this.visitBulkUpdateBO.serviceId = this.EvvtimesheetsendBO.serviceId;
    this.visitBulkUpdateBO.updateServiceId = this.bulkServiceId;
    this.visitBulkUpdateBO.updateAuthId = this.bulkUpdateAuthId;
    this.visitBulkUpdateBO.startDate = this.global.getDateTimeString(this.FromDateFilter);
    this.visitBulkUpdateBO.endDate = this.global.getDateTimeString(this.EndDateFilter);
    // console.log(this.visitBulkUpdateBO, 'visitBulkUpdateBO')

    this.TListService.updateMulitpleVisits(this.visitBulkUpdateBO).pipe(takeUntil(this.onDestroy$)).
      subscribe((data: any) => {
        this.IsButtonDisable = false;
        data = JSON.parse(data);
        if (data.length == 0) {
          this.toasterservice.success('Visits Updated Successfully!');
          this.getVisitListFilter();
          document.getElementById("updateauthevv").click();

        } else {
          this.errorlist = data;
          document.getElementById("errorpopup1").click();
        }
      },
        (err) => {
          this.IsButtonDisable = false;
          this.toasterservice.error(err, 'error');
          setTimeout(() => {
            this.saveErr = ""
          }, 8000);
        }
      );
  }

  closeBulkUpdate() {
    this.IsBulkUpdate = false;
  }

  openActivity(data) {
    this.Activities = JSON.parse(JSON.stringify(data?.activities));
    this.edittimesheetid = data?.id;
    document.getElementById("activitymodal").click();
  }

  saveActivity() {
    this.IsButtonDisable = true;
    var saveBO = new saveactivitybo();
    saveBO.activities = []
    this.Activities.forEach(element => {
      if (element.isSelected == true) {
        saveBO.activities.push(element.activityId)
      }

    });
    // this.activitiesList.forEach(e=> saveBO.activities.push(e.activityId))

    // saveBO.activities = this.activitiesList;
    saveBO.evvTsId = this.edittimesheetid;
    let url = "api/Visit/SaveEvvActivities";
    this.commonService.saveorUpdateFunctionwithResponseTypeJson(saveBO, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.IsButtonDisable = false;
          this.toasterservice.success("Acvities saved successfully");
          document.getElementById("activitymodal").click();
          this.getVisitListFilter();
        },
        (err: any) => {
          this.IsButtonDisable = false;
          this.toasterservice.error(err, "Error"), 8000;
        }
      );
  }

}







